import yup from "../../../utils/yup-extended";

const registerSchema = yup.object().shape({
  firstName: yup
    .string()
    .trim()
    .required("Please input your First name!")
    .matches(/^[A-Za-z\s-]+$/, "Only alphabets and hyphens are allowed for this field "),
  // .matches(/^[A-Za-z\s-]+$/, "Only alphabets and hyphens are allowed for this field "),
  lastName: yup
    .string()
    .trim()
    .required("Please input your Last name!")
    .matches(/^[A-Za-z\s-]+$/, "Only alphabets and hyphens are allowed for this field "), // .matches(/^[A-Za-z\s-]+$/, "Only alphabets and hyphens are allowed for this field "),
  emailAddress: yup
    .string()
    .trim()
    .email("That doesn't look like an email")
    .required("Please input your Email!"),
  country: yup.string().required("Please select your country!"),
  password: yup
    .string()
    .trim()
    .required("Please input your Password!")
    .min(
      8,
      "Password must contain at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number and 1 symbol"
    )
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9])/,
      "Password must contain at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number and 1 symbol"
    ),
});

export {registerSchema};
